import { ActivityActions, ActivityActionTypes, ActivityState } from './types';

export const defaultState = (): ActivityState => ({
  activity: {
    book: null,
    rounds: [],
    scene: null,
    storyElements: [],
    title: null,
  },
  currentRound: null,
  isLastRound: false,
  isActivityOver: false,
  showAffirmation: false,
  showNextButton: false,
});

export const reducers = (state: ActivityState, action: ActivityActions): ActivityState => {
  switch (action.type) {
    case ActivityActionTypes.SET_ACTIVITY:
      return { ...state, ...{ activity: action.payload } };
    case ActivityActionTypes.SET_CURRENT_ROUND:
      return { ...state, ...{ currentRound: action.payload } };
    case ActivityActionTypes.SET_IS_ACTIVITY_OVER:
      return { ...state, ...{ isActivityOver: action.payload } };
    case ActivityActionTypes.SET_SHOW_NEXT_BUTTON:
      return { ...state, ...{ showNextButton: action.payload } };
    case ActivityActionTypes.SET_SHOW_AFFIRMATION:
      return {
        ...state,
        ...{ showAffirmation: action.payload, isActivityOver: false, showNextButton: false },
      };
    case ActivityActionTypes.SET_IS_LAST_ROUND:
      return {
        ...state,
        ...{
          isLastRound:
            typeof action.payload === 'boolean'
              ? action.payload
              : action.payload === state.activity.rounds.length,
        },
      };
    default:
      return { ...state };
  }
};
